module.exports = __webpack_public_path__ + "media/images/3-5a2ca18069a822da503d5f45dc8d464d.png";